import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonToolbar, IonIcon, IonTextarea, IonAccordion, IonAccordionGroup, IonItem, IonLabel, IonFooter, IonInput } from '@ionic/react';
import { useParams } from 'react-router';
import React, { useState, useRef, useEffect } from 'react';
import { bonfire, mic, micOff, people, send, camera, videocam, apps, checkmarkCircleOutline } from 'ionicons/icons'
import LanguageSelector from '@/components/LanguageSelector';

import backend from '@/controllers/backend'
import PrevPage from '@/components/PrevPage';
import prefs, { Role } from '@/controllers/preferences'
import RoleSelector from './RoleSelector';

import { Message } from '@/components/Chat/Message'
import LLMTimings from '@/components/Chat/LLMTimings';
import LLMReplyCollector from '@/components/Chat/LLMReplyCollector';
import { KeepAwake } from '@capacitor-community/keep-awake';
import tts from '@/components/Chat/TTS';

import { getResponse, speechGetResponse } from '@/controllers/llm';

// TODO: add on mediapipe update
import { globalSTT, audioToWavBlob, blobToBase64} from '@/components/Chat/STT';
//import { STTAndroid } from './Chat/STTAndroid'
import { Filesystem, Directory } from "@capacitor/filesystem";

import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';

import { save_voice_msg } from '@/controllers/backend'
import { makePrompt } from '@/controllers/agent';
import { sleep } from '@/controllers/llm_client';

import Live2D from '@/controllers/Live2D';

const LessonPage: React.FC = () => {
  const { doc_id, doc_name, chapter_lesson_id } = useParams();

  const [chapter_id, lesson_id] = chapter_lesson_id.split("_")

  const started = useRef(false);
  const [title, setTitle] = useState(''+doc_name+': '+chapter_id+'.'+lesson_id)
  const [lesson, setLesson] = useState<{title: string, opener: string, prompt: string, learning_objectives: string[]}>({title: "Loading...", opener: "Loading...", prompt: "", learning_objectives: []})
  const role = useRef(-1)

  const later = async () => {
    // start by checking if doc_id is in the old format, and if so, forward
    if (!doc_id.match(/^\d+$/)) {
        const doc = await backend.fetch_legacy_doc(doc_id, doc_name)
        console.log(doc)
        window.location = (new URL(window.location).origin) + `/docs/${doc.id}/${doc.name}/${chapter_lesson_id}`
    }

    const chapter_lessons = await backend.chapter_lessons(doc_id, chapter_id);

    const lesson_data = chapter_lessons[lesson_id]
    setLesson(lesson_data)
    setTitle(lesson_data.title)

    //setTimeout(() => { Live2D.init() }, 1000);
  }

  useEffect(() => {
      if (started.current) return;
      started.current = true;

      if (tts.state.enabled)
        tts.speak(opener);

      later();
  })

  const live2dRef = useRef<HTMLCanvasElement>(null);
  // useEffect(() => {
  //   setTimeout(() => {
  //     Live2D.start(live2dRef.current!)
  //   }, 200);
  //   return () => { Live2D.stop(); }
  // }, [live2dRef])

  const onNextRole = async () => {
    const savedRoles = await prefs.get('conversationRoles');

    const nextIdx = (role.current + 1) % savedRoles.length;

    const nextRoleObj = savedRoles[nextIdx];
    role.current = nextIdx

    return nextRoleObj.name
  }

  // chat stuff

  const chatName = "fixme"

  const chatId = useRef<string | null>(null)
  const [lastFreeMsgId, setLastFreeMsgId] = useState<number>(3)
  const [messages, setMessages] = useState<Message[]>([{
    id: 2,
    role: "Greeter",
    type: "text",
    content: lesson.opener,
    timestamp: new Date().toISOString()
  }]);

  useEffect(() => {
    // update opener
    setMessages((messages) => {
      const new_msgs = [...messages]
      new_msgs[0].content = lesson.opener
      return new_msgs
    })
  }, [lesson])

  const llmReplyCollector = useRef(new LLMReplyCollector());
  const llmTimings = useRef(new LLMTimings());
  //const tts = useRef(globalTTS);
  const stt = useRef(globalSTT); // TODO: mediapipe update
  //const stt = useRef(new STTAndroid());
  const [STTEnabled, setSTTEnabled] = useState(stt.current.enabled);

  async function saveAttachment(name: string, data: string) {
    const parent = Directory.Data
    const dir = `chats/${chatName}/${chatId.current}/`
    await Filesystem.mkdir({
      path: dir,
      directory: parent,
      recursive: true
    }).catch(()=>null); //ignore error if directory is already there

    const path = `${dir}/${name}`
    return (await Filesystem.writeFile({
      path: path,
      data: data,
      directory: parent
    })).uri;
  }

  async function saveAttachmentByCopy(name: string, path: string) {
    const parent = Directory.Data
    const dir = `chats/${chatName}/${chatId.current}/`
    await Filesystem.mkdir({
      path: dir,
      directory: parent,
      recursive: true
    }).catch(()=>null); //ignore error if directory is already there

    const toPath = `${dir}/${name}`
    return (await Filesystem.copy({from: path, to: toPath, toDirectory: parent})).uri
  }

  // mediapipe update
  stt.current.onSpeechEnd = async (audio) => {
    console.log("speech end")
    console.log(audio)
    const uri = await blobToBase64(audioToWavBlob(audio))
    const r = await speechGetResponse(chatId, uri);
    if (r?.reply.segments[0].no_speech_prob > 0.08) {
      //tts.speak("Excuse me?")
      return;
    }

    //const uri = await saveAttachment(`${new Date().toISOString()}.wav`, await blobToBase64(audioToWavBlob(audio)));
    //saveMessage("audio", uri); // TODO: also save audio
    const msgId = await saveMessage("text", r!.reply.text);
    chatId.current = await backend.save_chat(messages, chatId.current)
    chatId.current = await save_voice_msg(chatId.current, msgId, uri)
  }

  // a ton of things in input ui can change depending on whether or not user
  // has typed anything already
  const [hasInput, setHasInput] = useState<boolean>(false);
  const [videoCallStatus, setVideoCallStatus] = useState<'idle' | 'connecting' | 'active'>('idle');

  // scroll into view
  const messagesEndRef = useRef<HTMLDivElement>(null);
  function scrollToBottom() {
    setTimeout(() => {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }, 40);
  }

  async function saveMessage(type: string, text: string) {
    Live2D.randomMotion();
    const id = lastFreeMsgId;
    const language = await prefs.get_language();

    let newRole: string = "";
    let userSpoke = false;
    let state = {
      skipped: false
    }

    let newMsgs = messages;
    while (true) {
      newRole = await onNextRole();
      if (newRole == "User" && !state.skipped) {
        break
      }
      if (newRole == "User" && state.skipped) {
        state.skipped = false;
        continue;
      }
      console.log(newRole, state.skipped);
    
      //setWipMessageRole(newRole);
      await (async () => {
      //setMessages((messages) => {
        if (!userSpoke) {
          userSpoke = true;
          newMsgs = [...newMsgs, {
            id: id,
            role: "User",
            type: type,
            content: text,
            timestamp: new Date().toISOString()
          } as Message]
          setMessages(newMsgs)
          scrollToBottom();
        }
        console.log(newMsgs)
        setLastFreeMsgId(x => ++x)

        const prompt = makePrompt(lesson, newRole, language, newMsgs)

        const llmMsgs = [
          {id: 1, role: "student", content: prompt, type: "text"} as Message, // system prompt
        ];

        if (!llmReplyCollector.current.llmRunning) {
          // debounce llm so that student can submit a ton of messages but llm is not
          // called multiple times
          llmReplyCollector.current.llmRunning = true;

          llmTimings.current.inferenceStart();
          //tts.current.inferenceStart();
          const reply = await getResponse(
            chatId.current!,
            llmMsgs.map((e) => {return {
              role: e.role == "student" ? "user" : "assistant",
              type: e.type,
              content: e.content,
              edited: e.edited,
              original: e.original
            }}))

            const newMsgPart = reply.reply;
            chatId.current = reply?.chat_id;

            if (newMsgPart === "...") {
              state.skipped = true;
              return
            } else {
              state.skipped = false;
              await sleep(1000);
  
              newMsgs = [...newMsgs,  {
                id: lastFreeMsgId,
                role: newRole,
                type: "text",
                content: newMsgPart,
                timestamp: new Date().toISOString(),
                first_token_time: llmTimings.current.firstTokenDelta,
                total_reply_time: llmTimings.current.responseTime,
                num_tokens: llmTimings.current.numTokens
              }]
              setLastFreeMsgId(x => ++x)
            }

            if (tts.state.enabled)
              tts.speak(newMsgPart);

            scrollToBottom();
        }

        setMessages(newMsgs);
        chatId.current = await backend.save_chat(newMsgs, chatId.current)
      })()
      //  return newMsgs;
      //});
      scrollToBottom();

      llmReplyCollector.current.llmRunning = false;
    }
    return id;
  }

  const inputRef = useRef<HTMLIonInputElement>(null);
  const sendMessageHandler = (e: any) => {
    e.preventDefault();
    const input = inputRef.current;
    const newMsgText = input.value.trim();
    if (newMsgText === "") return;
    saveMessage("text", newMsgText);

    input.value = "";
    detectInput();
  };

  const videoCallRef = useRef<HTMLButtonElement>(null);
  const toggleSTTRef = useRef<HTMLButtonElement>(null);
  
  /*
  Live2D.start(live2dRef.current!)
  */

  const toggleVideoCall = async () => {
    // FIXME: more synchronized toggling of stt and video call
    if (videoCallStatus === 'idle') {
      setVideoCallStatus('connecting');
      await Live2D.start(live2dRef.current!)
      await toggleSTT();
      setVideoCallStatus('active');
    } else if (videoCallStatus === 'active') {
      await toggleSTT();
      await Live2D.stop();
      //const canvas = live2dRef.current;
      //if (canvas) canvas.getContext('2d')?.clearRect(0,0, canvas.width, canvas.height)
      setVideoCallStatus('idle');
    }
  };

  const toggleSTT = async () => {
    console.log(toggleSTTRef)
    if (stt.current.enabled) {
      stt.current.stop();
      setSTTEnabled(false);
      KeepAwake.allowSleep();
    } else {
      toggleSTTRef.current!.disabled = true;
      toggleSTTRef.current!.style = "opacity: 0.4"
      try {
        await stt.current.start();
        setSTTEnabled(true);
        KeepAwake.keepAwake();
      } catch { console.log("no mic") }
      toggleSTTRef.current!.style = "opacity: 1"
      toggleSTTRef.current!.disabled = false;
    }
  }

  const detectInputRunning = useRef(false);
  const detectInput = () => {
    if (!detectInputRunning.current) {
      detectInputRunning.current = true;
      requestAnimationFrame(() => {
        const e = document.getElementById("chat-input")!;
        setHasInput(((e as HTMLIonInputElement)!.value! as string).trim().length > 0)
        detectInputRunning.current = false;
      })
    }
  }

  const takePicture = async () => {
    const image = await Camera.getPhoto({
      quality: 80,
      width: 1024,
      source: CameraSource.Camera,
      allowEditing: false, // I don't mind editing, but the flow seems a bit broken on my phone
                           // specifically you have to click "cancel" in order not to edit, which is
                           // confusing
      resultType: CameraResultType.Uri
    });

    // image.webPath will contain a path that can be set as an image src.
    // You can access the original file using image.path, which can be
    // passed to the Filesystem API to read the raw data of the image,
    // if desired (or pass resultType: CameraResultType.Base64 to getPhoto)

    
    // Can be set to the src of an image now
    const uri = await saveAttachmentByCopy(`${new Date().toISOString()}.jpg`, image.path!)
    saveMessage("image", uri);
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonButtons slot="end">
            <div className="pr-2">
              <LanguageSelector />
            </div>
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
          </IonToolbar>
        </IonHeader>
        <div className="max-w-4xl mx-auto p-4">
          <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-6">{title}</h2>
          <IonAccordionGroup className="rounded-lg overflow-hidden shadow-md">
            <IonAccordion value="prompt-editor">
              <IonItem slot="header" color="light" className="font-medium">
                <IonIcon icon={bonfire} className="mr-2" />
                <IonLabel className="text-gray-700 dark:text-gray-200">Lesson Plan</IonLabel>
              </IonItem>
              <div className="ion-padding bg-white dark:bg-gray-800" slot="content">
                <IonTextarea
                  labelPlacement="stacked"
                  fill="outline"
                  value={lesson.prompt}
                  rows={20}
                  className="min-h-[300px] font-mono text-sm"
                  onIonChange={e => setLesson((l) => {return {...l, prompt: e.detail.value ?? ""}})}
                />
              </div>
            </IonAccordion>
            <IonAccordion value="role-setup" className="overflow-hidden shadow-md">
              <IonItem slot="header" color="light" className="font-medium">
                <IonIcon icon={people} className="mr-2" />
                <IonLabel className="text-gray-700 dark:text-gray-200">Conversation Roles</IonLabel>
              </IonItem>
              <div className="ion-padding bg-white dark:bg-gray-800" slot="content">
                <RoleSelector />
              </div>
            </IonAccordion>
            <IonAccordion value="learning-objectives" className="overflow-hidden shadow-md">
              <IonItem slot="header" color="light" className="font-medium">
                <IonIcon icon={apps} className="mr-2" />
                <IonLabel className="text-gray-700 dark:text-gray-200">Learning Objectives</IonLabel>
              </IonItem>
              <div slot="content">
                  {(lesson.learning_objectives ?? []).map((objective, index) => (
                    <IonItem key={index}>
                      <IonIcon icon={checkmarkCircleOutline} className="text-green-500 text-xl mr-2" />
                      <p className="text-gray-800 dark:text-gray-200">{objective}</p>
                    </IonItem>
                  ))}
              </div>
            </IonAccordion>
          </IonAccordionGroup>

          <div className="mt-6 flex justify-center">
            <button 
              ref={videoCallRef}
              disabled={videoCallStatus === 'connecting'}
              className={`flex items-center justify-center gap-2 ${
                videoCallStatus === 'idle' ? 'bg-blue-600 hover:bg-blue-700' : 
                videoCallStatus === 'connecting' ? 'bg-gray-500 hover:bg-gray-600' : 
                'bg-red-600 hover:bg-red-700'
              } text-white font-bold py-3 px-6 rounded-full shadow-lg transition-all duration-300 transform hover:scale-105`}
              onClick={toggleVideoCall}
            >
              <IonIcon icon={videocam} className="text-xl" />
              <span>
                {videoCallStatus === 'idle' ? 'Start Video Call' : 
                 videoCallStatus === 'connecting' ? 'Connecting...' : 
                 'Stop Video Call'}
              </span>
            </button>
          </div>
        </div>
        <div className="max-sm:px-4 px-8 m-auto">
          <div className="mx-1">
            {[...messages].map((msg, key) => (
              <Message key={key} msg={msg} />
            ))}
            <div className='h-10' ref={messagesEndRef} />
          </div>
          
        </div>
      </IonContent>
      <canvas ref={live2dRef} style={{
        position: "absolute", zIndex: 10, pointerEvents: "none", // background: "red",
        width: "30vh", height: "85vh", bottom: "-35vh", right: "0"

      }} />
      <IonFooter className="bg-white dark:bg-zinc-900 py-3 z-50">
        <form onSubmit={sendMessageHandler} className="flex items-center justify-center gap-3 px-3">
        <button onClick={takePicture} type="button" className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-zinc-800 flex items-center justify-center">
          <IonIcon aria-hidden="true" icon={camera} style={{ fontSize: '1.5rem', color: 'inherit' }} />
        </button>
        <div className="px-2 flex-1 rounded-lg border border-gray-300 dark:border-zinc-700 focus:border-blue-400 bg-white dark:bg-zinc-800 text-black dark:text-white">
          <IonInput
            id="chat-input"
            className="dark:focus:border-blue-600"
            placeholder="Your reply..."
            onInput={detectInput}
            ref={inputRef}
          ></IonInput>
        </div>
         
        <button type="submit" className={`p-2 rounded-full hover:bg-blue-100 dark:hover:bg-blue-900 flex items-center justify-center text-blue-600 dark:text-blue-400 ${hasInput ? 'block' : 'hidden'}`}>
          <IonIcon aria-hidden="true" icon={send} style={{ fontSize: '1.5rem', color: 'inherit' }} />
        </button>
        <button onClick={toggleSTT} ref={toggleSTTRef} type="button" className={`p-2 rounded-full hover:bg-gray-100 dark:hover:bg-zinc-800 flex items-center justify-center ${hasInput ? 'hidden' : 'block'}`}>
          <IonIcon aria-hidden="true" icon={STTEnabled ? mic : micOff} style={{ fontSize: '1.5rem', color: 'inherit' }} />
        </button>
        </form>
      </IonFooter>
    </IonPage>
  );
};

export default LessonPage;
